import { ref } from '@vue/composition-api'
import { uniqBy, isEmpty } from 'lodash-es'

export const useActiveBDX = () => {
  const activeBDX = ref({
    id: undefined,
    lead_underwriter: [],
    follower_underwriter: [],
    tpa: undefined,
    broker: [],
    coverholder: [],
    ucr: undefined,
    fcp_status: false,
    fcp_start_date: '',
    currency_type: undefined,
    year_of_account: undefined,
    account_name: undefined,
    account_code: undefined,
    account_type: undefined,
    bdx_status: undefined,
  })

  const setActiveBDX = async (item) => {
    if (!item) return

    // Lead/follower underwriters, TPA, broker and coverholder are all
    // already on the record and part of what an edit shows/pre-fills -
    // visibility here isn't gated by the viewer's own company RLS lists
    // (LIQ-2028: RLS relationships no longer restrict company visibility).
    if (!isEmpty(item.underwriter)) {
      const validLeadUnderwriters = (item.underwriter || [])
        .filter((underwriter) => !!underwriter.lead)
        .map((underwriter) => ({
          id: underwriter.rls_underwriter.id,
          // The backend's UnderwriterSerializer already includes this -
          // nothing new to fetch, just something this composable was not
          // yet carrying through. slipshare itself is retired: BDX Edit
          // writes syndicate lines now, not that field.
          syndicates: underwriter.syndicates || []
        }))

      activeBDX.value.lead_underwriter = uniqBy(
        activeBDX.value.lead_underwriter.concat(validLeadUnderwriters),
        'id'
      )

      const validFollowerUnderwriters = item.underwriter
        .filter((underwriter) => !underwriter.lead)
        .map((underwriter) => ({
          id: underwriter.rls_underwriter.id,
          syndicates: underwriter.syndicates || []
        }))

      activeBDX.value.follower_underwriter = uniqBy(
        activeBDX.value.follower_underwriter.concat(validFollowerUnderwriters),
        'id'
      )
    }

    if (item.tpa) {
      activeBDX.value.tpa = [item.tpa.id]
    }

    if (item.broker) {
      activeBDX.value.broker = [item.broker.id]
    }

    if (item.coverholder) {
      activeBDX.value.coverholder = [item.coverholder.id]
    }

    activeBDX.value.id = item.id || undefined
    activeBDX.value.umr = item.umr || undefined
    activeBDX.value.risk_code = item.risk_code || undefined
    activeBDX.value.cat_code = item.cat_code || undefined
    activeBDX.value.section_no = item.section_no || undefined
    activeBDX.value.ucr = item.ucr || undefined
    activeBDX.value.fcp_status = item.fcp_status
    activeBDX.value.fcp_start_date = item.fcp_start_date || ''
    activeBDX.value.currency_type = item.currency_type || undefined
    activeBDX.value.year_of_account = item.year_of_account || undefined
    activeBDX.value.continuous_contract = item.continuous_contract || false
    activeBDX.value.account_name = item.account_name || undefined
    activeBDX.value.account_code = item.account_code || undefined
    activeBDX.value.account_type = item.account_type || undefined
    activeBDX.value.jurisdiction = item.jurisdiction || undefined
    activeBDX.value.bdx_status = item.bdx_status || undefined
    activeBDX.value.umr_rc_cc_sn = item.umr_rc_cc_sn || undefined
  }

  const resetActiveBDX = () => {
    activeBDX.value = {
      id: undefined,
      lead_underwriter: [],
      follower_underwriter: [],
      tpa: undefined,
      broker: undefined,
      coverholder: undefined,
      ucr: undefined,
      fcp_status: false,
      fcp_start_date: '',
      currency_type: undefined,
      year_of_account: undefined,
      account_name: undefined,
      account_code: undefined,
      account_type: undefined,
      jurisdiction: undefined,
      bdx_status: undefined,
    }
  }

  return {
    activeBDX,

    setActiveBDX,
    resetActiveBDX
  }
}
